import script from "./search-fields.vue?vue&type=script&setup=true&lang=js"
export * from "./search-fields.vue?vue&type=script&setup=true&lang=js"

import "./search-fields.vue?vue&type=style&index=0&id=7690c416&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/ciyc-web-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7690c416"]])

export default __exports__